<template>
  <div class="roles">
    <!-- hello -->
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>角色列表</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/roles/create')"
          >创建角色</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 表格 -->
      <tz-table :tableData="tableData" :columns="columns" />
      <!-- 表格 -->

      <!-- 分页 -->
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="params.pagenum"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="400"
      >
      </el-pagination> -->
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑 -->
    <Edit :state="editState" @close="editState = false"></Edit>
    <EditAuth :state="editAuthState" @close="editAuthState = false"></EditAuth>
    <!-- 编辑 end -->
  </div>
</template>

<script>
import tableData from '~mock/roles/index.js'
import Edit from './components/Edit.vue'
import EditAuth from './components/EditAuth.vue'

export default {
  components: {
    Edit,
    EditAuth
  },
  data() {
    return {
      // 编辑
      editState: false,
      editAuthState: false,

      // 筛选模型
      params: {
        pagenum: 1
      },

      // 表数据
      tableData: tableData.data,
      // 表格列
      columns: [
        { title: '编号', field: 'id' },
        { title: '角色名称', field: 'role_name' },
        { title: '角色描述', field: 'role_desc' },
        {
          title: '操作',
          width: '260',
          type: 'btn',
          payload: [
            {
              name: '分配权限',
              type: 'primary',
              click: (row) => {
                console.log('分配', row)
                // 1 显示
                this.editAuthState = true
                // 2.
              }
            },
            {
              // name: "编辑",
              icon: 'el-icon-edit',
              type: 'success',
              click: (row) => {
                console.log('编辑', row)
                // 1 显示
                this.editState = true
                // 2.
              }
            },
            {
              // name: "删除",
              icon: 'el-icon-delete',
              type: 'danger',
              click: (row) => this.deleteFn(row)
            }
          ]
        }
      ]
    }
  },
  methods: {
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
    }
  }
}
</script>

<style></style>
